export enum PlatformOptions {
	WEB = 'web',
	MOBILE = 'mobile'
}

export type Platform = `${PlatformOptions}`;

export type TokenPair = {
	accessToken: string;
	refreshToken: string;
	tokenType: string;
	expiresIn: number;
	sessionExpiresAt: number;
};
